export interface Category {
  id: string;
  name: string;
  url: string;
  icon: string;
  description: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Обувь',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Кроссовки, кеды, ботинки и другая обувь от проверенных поставщиков Китая',
    image: 'https://readdy.ai/api/search-image?query=Professional%20product%20photography%20of%20white%20minimalist%20fashion%20sneakers%20on%20warm%20beige%20linen%20fabric%20surface%20with%20soft%20diffused%20natural%20window%20light%20gentle%20shadow%20detail%20clean%20composition%20editorial%20style%20no%20text%20no%20people&width=600&height=450&seq=cat-img-shoes-new-v2&orientation=landscape',
  },
  {
    id: 'hoodies',
    name: 'Худи / Свитера',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Толстовки, свитшоты, худи и теплые вещи напрямую с фабрик',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20product%20photography%20of%20an%20oversized%20pastel%20beige%20hoodie%20folded%20neatly%20on%20light%20cream%20textured%20paper%20background%20with%20dried%20flowers%20subtle%20natural%20shadows%20soft%20editorial%20lighting%20aesthetic%20minimal%20composition&width=600&height=450&seq=cat-img-hoodies-new-v2&orientation=landscape',
  },
  {
    id: 'tshirts',
    name: 'Футболки',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Брендовые и базовые футболки из Китая по выгодным ценам',
    image: 'https://readdy.ai/api/search-image?query=Premium%20product%20photography%20of%20a%20soft%20sage%20green%20cotton%20tshirt%20elegantly%20draped%20on%20light%20oak%20wooden%20surface%20with%20gentle%20morning%20sunlight%20casting%20subtle%20shadows%20minimal%20Scandinavian%20aesthetic%20editorial%20fashion%20composition&width=600&height=450&seq=cat-img-tshirts-new-v2&orientation=landscape',
  },
  {
    id: 'jackets',
    name: 'Куртки',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-t-shirt-2-line',
    description: 'Пуховики, ветровки, бомберы и джинсовые куртки оптом и в розницу',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20editorial%20product%20shot%20of%20a%20lightweight%20olive%20green%20bomber%20jacket%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20warm%20oatmeal%20textured%20wall%20with%20soft%20natural%20light%20streaming%20from%20side%20gentle%20shadows%20calm%20aesthetic&width=600&height=450&seq=cat-img-jackets-new-v2&orientation=landscape',
  },
  {
    id: 'pants',
    name: 'Брюки / Шорты',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Джинсы, брюки, шорты, спортивные штаны от китайских производителей',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20tailored%20beige%20linen%20trousers%20laid%20flat%20on%20light%20cream%20marble%20surface%20with%20a%20dried%20palm%20leaf%20accent%20soft%20natural%20daylight%20streaming%20through%20sheer%20curtains%20editorial%20minimal%20style%20warm%20neutral%20palette&width=600&height=450&seq=cat-img-pants-new-v2&orientation=landscape',
  },
  {
    id: 'headwear',
    name: 'Головные уборы',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-bear-smile-line',
    description: 'Кепки, бейсболки, шапки, панамы и другие аксессуары для головы',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20product%20photography%20of%20a%20premium%20structured%20baseball%20cap%20in%20warm%20sand%20color%20placed%20on%20a%20light%20terracotta%20ceramic%20plate%20against%20soft%20cream%20wall%20backdrop%20with%20gentle%20diffused%20afternoon%20light%20editorial%20still%20life%20composition&width=600&height=450&seq=cat-img-headwear-new-v2&orientation=landscape',
  },
  {
    id: 'sets',
    name: 'Комплекты',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Готовые комплекты одежды: спортивные костюмы, casual сеты и многое другое',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20a%20coordinated%20two%20piece%20loungewear%20set%20in%20warm%20oatmeal%20tones%20elegantly%20arranged%20on%20light%20cream%20textured%20surface%20with%20soft%20natural%20window%20light%20gentle%20shadows%20minimalist%20fashion%20photography%20aesthetic&width=600&height=450&seq=cat-img-sets-new-v2&orientation=landscape',
  },
  {
    id: 'underwear',
    name: 'Нижнее бельё',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-line',
    description: 'Качественное нижнее бельё, носки и базовые вещи по доступным ценам',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20photography%20of%20soft%20cotton%20basics%20neatly%20folded%20on%20light%20bamboo%20tray%20with%20a%20sprig%20of%20lavender%20on%20warm%20cream%20linen%20surface%20diffused%20natural%20light%20editorial%20calm%20composition%20neutral%20tones&width=600&height=450&seq=cat-img-underwear-new-v2&orientation=landscape',
  },
  {
    id: 'jersey',
    name: 'Джерси',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-trophy-line',
    description: 'Спортивные джерси, футбольная и баскетбольная форма всех клубов',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20product%20photography%20of%20a%20premium%20athletic%20sports%20jersey%20in%20deep%20forest%20green%20elegantly%20draped%20over%20a%20minimalist%20stool%20against%20warm%20beige%20backdrop%20with%20soft%20dramatic%20side%20lighting%20editorial%20sportswear%20aesthetic%20clean%20composition&width=600&height=450&seq=cat-img-jersey-new-v2&orientation=landscape',
  },
  {
    id: 'accessories',
    name: 'Аксессуары',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Очки, часы, украшения, чехлы и стильные аксессуары из Китая',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20still%20life%20product%20photography%20of%20elegant%20sunglasses%20and%20a%20minimalist%20watch%20placed%20on%20light%20travertine%20stone%20surface%20with%20soft%20natural%20light%20warm%20neutral%20tones%20editorial%20composition%20sophisticated%20aesthetic%20calm%20mood&width=600&height=450&seq=cat-img-accessories-new-v2&orientation=landscape',
  },
  {
    id: 'bags',
    name: 'Сумки',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    description: 'Рюкзаки, поясные сумки, дорожные чемоданы и сумки через плечо',
    image: 'https://readdy.ai/api/search-image?query=Premium%20product%20photography%20of%20a%20structured%20canvas%20backpack%20in%20warm%20taupe%20color%20resting%20on%20a%20light%20oak%20bench%20against%20cream%20wall%20with%20soft%20overhead%20natural%20light%20gentle%20shadows%20editorial%20style%20minimalist%20composition&width=600&height=450&seq=cat-img-bags-new-v2&orientation=landscape',
  },
  {
    id: 'belts',
    name: 'Ремни',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Кожаные ремни, текстильные ремни и стильные аксессуары для талии',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20of%20a%20handcrafted%20leather%20belt%20in%20cognac%20brown%20gracefully%20coiled%20on%20light%20cream%20linen%20fabric%20with%20soft%20natural%20window%20light%20casting%20subtle%20shadows%20editorial%20minimal%20aesthetic%20warm%20tones&width=600&height=450&seq=cat-img-belts-new-v2&orientation=landscape',
  },
  {
    id: 'perfumes',
    name: 'Парфюмерия',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Оригинальные и лицензионные ароматы мировых брендов из Китая',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20product%20photography%20of%20an%20amber%20glass%20perfume%20bottle%20with%20delicate%20floral%20arrangement%20on%20light%20cream%20marble%20surface%20soft%20natural%20backlight%20creating%20a%20warm%20glow%20editorial%20beauty%20composition%20elegant%20aesthetic%20refined%20mood&width=600&height=450&seq=cat-img-perfumes-new-v2&orientation=landscape',
  },
  {
    id: 'other',
    name: 'Прочее',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Электроника, товары для дома, игрушки и другие категории товаров',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20product%20photography%20of%20assorted%20lifestyle%20items%20including%20headphones%20notebook%20ceramics%20and%20small%20decor%20objects%20arranged%20on%20light%20cream%20textured%20surface%20with%20soft%20natural%20light%20warm%20neutral%20tones%20eclectic%20but%20harmonious%20composition&width=600&height=450&seq=cat-img-other-new-v2&orientation=landscape',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';